import WorkshopCard from "./WorkshopCard";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import { useGetThreeRandomWorkshopsQuery } from "../../../app/store/api/workshopApi";

export default function MarketingWorkshops() {

    const { t } = useTranslation();
    const { isMobile, isTablet } = useWindowSize();
    const {data:workshops,isLoading:loading} = useGetThreeRandomWorkshopsQuery();

    while (loading) {
        return null; // or a loading spinner
    }

    return (
        <Box className="marketing-workshops-container">
            <Box className="marketing-workshops-header" >
                <Typography variant={isMobile ? "h4" : isTablet ? "h3" : "h2"} component="h2" sx={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 2, color: 'white' }}>
                    {t('marketingWorkshops.headerText')}
                </Typography>
                <Typography variant="body1" component="p" sx={{ textAlign: 'center', maxWidth: 600, margin: '0 auto', color: 'white' }}>
                    {t('marketingWorkshops.subHeaderText')}
                </Typography>
            </Box>
            <Grid container spacing={3} className="marketing-workshops" >
                {workshops?.map((workshop) => (
                    <WorkshopCard key={workshop.id} workshop={workshop} />
                ))}
            </Grid>
        </Box>
    );
}